import React from 'react';
import PropTypes from 'prop-types';
import { Flex } from 'onefaceui-react-components';

import Icon from 'react/components/Icon';
import { formatUnitSystem, getResourceTo } from 'react/utils/utils';
import { iconConformity, iconUnconformity } from 'react/utils/stopDetailsPopupBase64Icons.js';

const getConformityValue = (conformity) => (
  (conformity === 'Y' && <Icon iconUrl={iconConformity}/>) ||
  (conformity === 'N' && <Icon iconUrl={iconUnconformity}/>) ||
  '-'
);

const commonFlexProps = {
  justifyContent: 'space-between',
  alignItems: 'center',
  className: 'coordinates-item'
};

const Coordinates = ({ stop }) => {
  const hasSignature = !!stop.get('hasSignature');
  const lat = stop.get('latitude');
  const lng = stop.get('longitude');
  const arrivalLat = stop.get('arrivalLatitude');
  const arrivalLng = stop.get('arrivalLongitude');
  const departureLat = stop.get('departureLatitude', '');
  const departureLng = stop.get('departureLongitude', '');
  const cancelLat = stop.get('cancelLatitude', '');
  const cancelLng = stop.get('cancelLongitude', '');
  const distFromArrivalToStop = stop.get('distanceFromArrivalToStopInMeters');
  const distFromCancelToStop = stop.get('distanceFromCancelToStopInMeters');
  const distFromASignatureToStop = stop.get('distanceFromSignatureToStopInMeters', hasSignature ? distFromArrivalToStop : '');
  const arrivalConformity = stop.get('arrivalConformity');
  const signatureConformity = stop.get('signatureConformity', '');
  const cancelConformity = stop.get('cancelConformity', '');
  const signatureLat = stop.get('signatureLatitude', hasSignature ? arrivalLat : '');
  const signatureLng = stop.get('signatureLongitude', hasSignature ? arrivalLng : '');
  const customerLatLng = `${lat}, ${lng}`;
  const arrivalLatLng = arrivalLat && arrivalLng ? `${arrivalLat}, ${arrivalLng}` : '-';
  const departureLatLng = departureLat && departureLng ? `${departureLat}, ${departureLng}` : '-';
  const cancelLatLng = cancelLat && cancelLng ? `${cancelLat}, ${cancelLng}` : '-';
  const distBetweenStopArrival = distFromArrivalToStop ? formatUnitSystem(distFromArrivalToStop) : '-';
  const distBetweenCancelStop = distFromCancelToStop ? formatUnitSystem(distFromCancelToStop) : '-';
  const signatureLatLng = signatureLat && signatureLng ? `${signatureLat}, ${signatureLng}` : '-';
  const distBetweenSignatureStop = distFromASignatureToStop ? formatUnitSystem(distFromASignatureToStop) : '-';

  return (
    <>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.location.latlong')}</div>
        <div>{customerLatLng}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.arrival.latlong')}</div>
        <div>{arrivalLatLng}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.departure.latlong')}</div>
        <div>{departureLatLng}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.accuracyMeters')}</div>
        <div>{distBetweenStopArrival}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.arrivalConformity')}</div>
        <div>{getConformityValue(arrivalConformity)}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.signature.latlong')}</div>
        <div>{signatureLatLng}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.signature.distance')}</div>
        <div>{distBetweenSignatureStop}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.signatureConformity')}</div>
        <div>{getConformityValue(signatureConformity)}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.cancel.latlong')}</div>
        <div>{cancelLatLng}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.cancel.distance')}</div>
        <div>{distBetweenCancelStop}</div>
      </Flex>
      <Flex {...commonFlexProps}>
        <div>{getResourceTo('Stop.popup.cancelConformity')}</div>
        <div>{getConformityValue(cancelConformity)}</div>
      </Flex>
    </>
  );
};

Coordinates.propTypes = {
  routeId: PropTypes.oneOfType([ PropTypes.string, PropTypes.number]).isRequired,
  stopId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  stop: PropTypes.object.isRequired
}

export default Coordinates;
